import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c4c047ec&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports